/**
 * 
 */
export const mescServicesUrl = {

    'LOCAL': 'http://localhost:2076/api/',
    'DEV': 'https://mesc-service-dev.musea2.azure.ext.gm.com/mesc-dashboard-service/api/',
    'QA': 'https://mesc-service-api-ocf-qa.apps.pcfepgstg1mi.gm.com/api/',
    'TEST': 'https://mesc-service-api-ocf-test.apps.pcfepgstg1mi.gm.com/api/',
    'PROD': 'https://mesc-service.musea2.azure.ext.gm.com/mesc-dashboard-service/api/',

};
/**
 * 
 */
export const mescAppUrl = {

    'LOCAL': 'https://localhost.gm.com/',
    'DEV': 'https://mesc-dev.musea2.azure.ext.gm.com/',
    'QA': 'https://mesc-ui-ocf-qa.apps.pcfepgstg1mi.gm.com/',
    'TEST': 'https://mesc-ui-ocf-test.apps.pcfepgstg1mi.gm.com/',
    'PROD': 'https://mesc.musea2.azure.ext.gm.com/',

};
/**
 * 
 */
export const mescModules = [
    {
        title: 'CTWR',
        subtitle: 'Casting Tooling Work Request',
        description: 'Create and manage Work Requests.',
        url: 'https://mfg-gateway-test.gm.com/ctwr/ui/#/',
        route: '/CTWR',
        imageClass: 'image-ctwr'
    } as MescModuleView,
    {
        title: 'PHF',
        subtitle: 'Part Handling Forum',
        description: 'Manage and optimize part handling and storage.',
        url: 'https://mesc-ui-ocf-test.apps.pcfepgstg1mi.gm.com/phf/#/PHF',
        route: '/PHF',
        imageClass: 'image-phf'
    } as MescModuleView,
]
/**
 * 
 */
export class MescModuleView {
    title: string;
    subtitle: string;
    description: string;
    url: string;
    route: string;
    imageClass?: string;
}



